import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/_components';

export function Loading({ className }: { className?: string }) {
  return (
    <ul className={twJoin('list-none', className)}>
      {Array.from({ length: 6 }).map((_, index) => (
        <li
          key={index}
          className="border-c-border-muted text-accent flex h-12 flex-nowrap items-center justify-between gap-2 border-b dark:text-white"
        >
          <div className="flex flex-1 items-center gap-1.5">
            <Skeleton className="h-8 w-8 shrink-0 grow-0 rounded-full" />
            <div className="flex w-full flex-col gap-1">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
